<template>
  <div class="container" :class="{ me: me }">
    <!-- <AvatarComp v-if="!me" :profile="profile" :name="usrNick.substring(0, 1)" :color="prfBgCol" /> -->
    <div>
      <div class="id" v-if="!me">
        관리자
      </div>
      <div class="chat-bubble">
          <!-- {{ chat }} -->
        <span v-for="(part, index) in parsedParts" :key="index">
          <template v-if="isUrl(part)">
            <a class="link" :href="formatUrl(part)" target="_blank" rel="noopener noreferrer">{{ part }}</a>
          </template>
          <template v-else>
            {{ part }}
          </template>
        </span>
      </div>
    </div>
    <h4 class="chat-time">{{ time }}</h4>
  </div>
</template>

<script>
// import AvatarComp from '@/components/AvatarComp.vue'
// import BaseBtn from '@/components/BaseBtn.vue'

export default {
  name: 'ChatBubble',
  props: {
    me: Boolean,
    chat: String,
    time: String,
    regrId: String,
    usrNm: String,
    chatSeq: {
      type: Number,
      default: 0
    },
  },
  components: {
    // AvatarComp,
    // BaseBtn,
  },
  computed: {
    parsedParts() {
      // 공백 단위로 분리
      return this.chat.split(/\s+/);
    }
  },
  data() {
    return {}
  },

  mounted() {},

  methods: {
    isUrl(str) {
      return /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}/.test(str);
    },
    formatUrl(str) {
      return str.startsWith('http') ? str : 'http://' + str;
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.container {
  font-size: 12px;
  font-weight: 600;
  display: flex;
  /* align-items: flex-end; */
  gap: 5px;
  &:hover {
    cursor: default;
    .report-btn {
      visibility: visible;
      opacity: 1;
    }
  }
  &.me {
    flex-direction: row-reverse;
    .chat-bubble {
      border-top-right-radius: 0;
      border-top-left-radius: 30px;
      background-color: #459dff;
    }
  }
}
.id {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  margin: 2px 0 6px 0;
  color: #459dff;
}

.chat-bubble {
  position: relative;
  max-width: 252px;
  padding: 10px;
  background-color: #bbb;
  border-radius: 30px;
  border-top-left-radius: 0;
  
  p {
    border-radius: 30px;
    padding: 0 10px 5px 10px;
    font-size: 12px;
  }
  @media (max-width: $mobile) {
    max-width: 220px;
  }
}
.chat-time {
  font-size: 11px;
  white-space: nowrap;
  align-self: flex-end;
  opacity: 0.6;
}
.avatar-container {
  margin-right: 5px;
}
.report-btn {
  visibility: hidden;
  opacity: 0;
  margin-left: 10px;
  h4 {
    padding-bottom: 0;
    font-weight: 400;
    margin-left: -4px;
  }
}

.link {
  text-decoration: underline
}
</style>
